// 멤버 역할 인터페이스
export interface IMemberRole {
  id?: string;
  name: string; // 역할 키 (예: designer, manager)
  label: string; // 역할 표시명 (예: 디자인스텝, 정산스텝)
  description?: string; // 역할 설명
  allowedSettings: string[]; // 접근 가능한 설정 ID 배열
  userIds?: string[]; // 이 역할을 가진 유저 ID 배열
  order?: number;
  createdAt?: any;
  updatedAt?: any;
}

export const MEMBER_ROLE_COLLECTION = 'memberRoles';
